"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Check = _ref => {
  let {
    title = 'Check',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 24.219l14.125-14.125 1.875 1.875-16 16-7.438-7.438 1.875-1.875z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Check);
Check.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Check",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Check'",
        "computed": false
      },
      "required": false
    }
  }
};